// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"afae3705","82":"93fee198","306":"42409159","419":"1490a516","530":"eee9fe54","632":"73f1311f","880":"cfa876a2"}[chunkId] + ".chunk.css";
};